import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex max-w-[1280px] flex-col items-center justify-center px-4 py-24 text-center md:px-6">
      <span className="font-heading text-7xl font-black text-primary-200 md:text-9xl">404</span>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-900">抱歉，这个页面走丢了</h1>
      <p className="mt-2 text-sm text-foreground-500">
        你访问的地址不存在：<span className="font-mono text-foreground-700">{location.pathname}</span>
      </p>
      <p className="mt-1 text-sm text-foreground-500">也许链接有误，或者该内容已被调整。</p>
      <div className="mt-7 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          返回首页
        </Link>
        <Link
          to="/search"
          className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          搜索新闻
        </Link>
      </div>
    </div>
  );
}